exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".hunter-page .app-main{background-color:#fff;padding:5rem 0 0 0 !important}.hunter-page .content iframe.template-portal{width:100%;height:100%;height:100vh}.hunter-page .navbar{display:block !important}.hunter-page .ng-hide{display:block !important}", ""]);

// exports
